import { SET_CAMPAIGN_LIST, SET_SINGLE_CAMPAIGN_DETAIL, SET_SINGLE_CAMPAIGN_DETAIL_PROFILES, SET_SINGLE_CAMPAIGN_DETAIL_PROFILES_LOADER } from "../actions/types";

const initialState = {
    campaignList: [],
    campaignProfileList: [],
    campaignListCount: null,
    campaignProfileListCount: null,
    singleCampaignDetail: {},
    campaignProfileLoader: false
};
export default function (state = initialState, action) {
    const { type, payload, count } = action;
    switch (type) {
        case SET_CAMPAIGN_LIST:
            return {
                ...state,
                campaignList: payload,
                campaignListCount: count
            }
        case SET_SINGLE_CAMPAIGN_DETAIL:
            return {
                ...state,
                singleCampaignDetail: payload,
                campaignProfileListCount: count
            }

        case SET_SINGLE_CAMPAIGN_DETAIL_PROFILES:
            return {
                ...state,
                campaignProfileList: payload,
                campaignProfileLoader: false
            }
        case SET_SINGLE_CAMPAIGN_DETAIL_PROFILES_LOADER:
            return {
                ...state,
                campaignProfileLoader: payload
            }
        default:
            return state;
    }
}
